import { render, staticRenderFns } from "./select.vue?vue&type=template&id=70b2b2c6&scoped=true&"
import script from "./select.js?vue&type=script&lang=js&"
export * from "./select.js?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./select.scss?vue&type=style&index=1&id=70b2b2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2b2c6",
  null
  
)

export default component.exports